export default "__VITE_ASSET__CfXaW8E1__"